
    import '/home/ec2-user/Youlify-Design/components/card/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["card-demo-basic","card-demo-border-less","card-demo-simple","card-demo-flexible-content","card-demo-in-column","card-demo-loading","card-demo-grid-card","card-demo-inner","card-demo-tabs","card-demo-meta","card-demo-component-token","card-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/card/index.zh-CN.md?type=demo')
};